var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardWidgetLineSmooth',{staticClass:"widget-cassa-disavanzo",attrs:{"title":"Cassa e Disavanzo","dataY":_vm.dataY,"dataX":_vm.dataX,"legend":"Cassa e Disavanzo"}})}
var staticRenderFns = []

export { render, staticRenderFns }